import { Injectable, inject, signal } from '@angular/core';
import { OpportunityApi } from '@/core/opportunity/opportunity-api.service';

@Injectable({
  providedIn: 'root',
})
export class OfferStore {
  private api = inject(OpportunityApi);

  private _loading = signal(false);
  private _creationError = signal(false);

  public loading = this._loading.asReadonly();
  public creationError = this._creationError.asReadonly();

  async createOpportunity(): Promise<void> {
    if (this._loading()) return;
    this._loading.set(true);
    this._creationError.set(false);
    try {
      await this.api.createOpportunity();
    } catch {
      this._creationError.set(true);
    } finally {
      this._loading.set(false);
    }
  }
}
